import React from "react";
import { useNavigate } from "react-router-dom";
import RollTable from "../components/RollTable";
import { Link } from 'react-router-dom';

const ADMIN_MODE = false;  // change to false to lock

function RolloutPage({ setRollToEdit, currentAircraft }) {

   const tail = String(
    currentAircraft?.tailNumber ??
    currentAircraft?.id ??
    currentAircraft?.tail ??
    ""
).trim().toUpperCase();

  const navigate = useNavigate();
  //const tail = currentAircraft?.tailNumber || "";

  const onEdit = (roll) => {
    setRollToEdit(roll);
    const id = roll?.id ?? "";
    navigate(`/edit-roll/${encodeURIComponent(id)}`);
  };

  const protectedAircraft = [
        //"N6727N",
        //"N7117V",
        //"N988BG"
    ];
    const isProtectedAircraft = protectedAircraft.includes(tail);

    const canEditRollout =
        ADMIN_MODE || !isProtectedAircraft;

    console.log("ROLLOUT LOCK CHECK:", {
        tail,
        ADMIN_MODE,
        protectedAircraft,
        isProtectedAircraft,
        canEditRollout
    });        

  return (
    <article className="App-article">
      <RollTable 
      tail={tail} 
      onEdit={onEdit}
      canEdit={canEditRollout} 
      />
{/* ============================================================
            OPTIONAL AD PLACEMENT
          ============================================================ */}
              <div className="ad-banner">
                  Ad Space
                </div>
                  
                {/* ============================================================
                  RELATED TOOLS / INTERNAL LINKS
                ============================================================ */}
                <section className="related-tools-section">
                <div className="tool-content">
                <h2 >Related Tools</h2>
                  
                <p >
                <Link to="/">HomePage</Link> |
                <Link to="/vsps">Vspeed</Link> |
                <Link to="/navlog">NavLog</Link> |
                <Link to="/wtbals">Weight & Balance</Link> |
                <Link to="/density-altitude">Density Altitude</Link> |
                <Link to="/cw">Crosswind/Headwind</Link> |
                <Link to="/mnvr">Maneuvers</Link> |
                <Link to="/airframe-powerplant">Airframe & Powerplant</Link> |
                <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link> |
                <Link to="/adjustable-amortization">Aircraft Loan</Link>
                
                </p>
            </div>
          </section>
    </article>
  );
}

export default RolloutPage;